import { render, staticRenderFns } from "./ConfirmationWarning.vue?vue&type=template&id=e52d72b8&"
import script from "./ConfirmationWarning.vue?vue&type=script&lang=js&"
export * from "./ConfirmationWarning.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports